<script>
	import { onMount } from "svelte";
	import { push, pop, replace } from "svelte-spa-router";
	import Icon from "svelte-awesome";
	import { faBars } from "@fortawesome/free-solid-svg-icons";
	import Break from "../../components/break/Break.svelte";
	import { onBreak } from "../../components/break/stores";
	import GetRequestApiInstance from "../../services/ServiceRequestApi";
	import GetReactionTimeInstance from "../../services/ServiceReactionTime";
	// instances services
	const requestApiInstance = GetRequestApiInstance();
	const reactionTimeInstance = GetReactionTimeInstance();
	// constantes
	const GAME_NAME = "f1-start-timer";
	const INITIAL_COUNTDOWN = 5;
	// paramètres
	export let params = {};
	let difficulty = params.difficulty;
	// variables
	// result
	let result = {
		game_name: GAME_NAME,
		difficulty: difficulty,
		time_reaction: 0
	};
	let isStart = false;
	let countdownIsStart = false;
	let countdown = INITIAL_COUNTDOWN;
	let interval;
	let timeout;
	
	let bestTimeReaction;

	onMount(() => {
		onBreak.set(false);
		bestTimeReaction = getBestTimeReaction();
	});
	
	async function getBestTimeReaction() {
		let responseBestTimeReaction = await requestApiInstance.get(`bestResult/${GAME_NAME}/${difficulty}`);
		return responseBestTimeReaction[0].time_reaction;
	}

	function initEnd() {
		isStart = false;
		countdownIsStart = false;
		clearInterval(interval);
		clearTimeout(timeout);
		result.time_reaction = 0;
		countdown = INITIAL_COUNTDOWN;
	}
	
	function stop() {
		let arrayReactionTime = reactionTimeInstance.getArrayReactionTime();
		result.time_reaction = arrayReactionTime[0];
		reactionTimeInstance.resetArrayReactionTime();
        
		push("/ranking/" + GAME_NAME + "/" + difficulty + "/" + btoa("game_name=" + result.game_name + "&difficulty=" + result.difficulty + "&time_reaction=" + result.time_reaction));
	}

	function startCountdown() {
		if(!$onBreak && !isStart && !countdownIsStart) {
			countdownIsStart = true;
			interval = setInterval(function () {
				if (countdown > 0 && countdownIsStart) {
					countdown--;
				} else if(countdown == 0) {
					clearInterval(interval);
					let setTimeoutValue = randomTimeBeforeStart();
					timeout = setTimeout(function() {
						isStart = true;
						reactionTimeInstance.startTimeReaction();
					}, setTimeoutValue);
				}
			}, 1000);
		}
	}

	function handleStartAndResult() {
		if (isStart) {
			timeToReact();
			stop();
		} else {
			if(countdownIsStart) {
				initEnd();
				stop();
			} else {
				startCountdown();
			}
		}
	}

	function randomTimeBeforeStart() {
		return Math.floor(Math.random() * 22 + 10) * 100;
	}

	function timeToReact() {
		reactionTimeInstance.saveTimeToReact();
	}

	function handleBreakButton() {
		onBreak.set(true);
		countdownIsStart = false;
		initEnd();
	}
</script>

<style>
	.message {
		@apply font-thin text-3xl select-none pb-16 text-center;
	}
	.col-led {
		@apply flex flex-col items-center bg-black m-auto;
		width: calc(85% / 5);
	}
	.led {
		@apply w-14 h-14 m-4 rounded-full;
		background: #616161;
	}
	.on {
		background: red;
	}
</style>

<div class="container-global">
	{#if $onBreak}
		<Break gameName={GAME_NAME} difficulty={difficulty} />
	{/if}
	<div class="h-1/5">
		<div class="header">
			<div class="text-right pt-4 m-auto w-5/6">
				<span class="cursor-pointer" on:click={handleBreakButton}>
					<Icon data={faBars} scale="1.4" />
				</span>
			</div>
			<div class="middle-header py-4 px-4 text-center">
				<div>
					<span class="text-2xl">
						Meilleur temps de réaction : {#await bestTimeReaction}-{:then result}{result}<span class="text-xl ml-1">ms</span>{/await}
					</span>
				</div>
			</div>
		</div>
	</div>
	<div class="h-4/5 flex flex-col justify-center items-center" on:mousedown={handleStartAndResult}>
		<div class="message">
			{#if !countdownIsStart}
				Cliquez ici pour commencer !
			{:else}
				{#if isStart}
					Cliquez !
				{:else}
					Cliquez quand les lumières s'éteignent
				{/if}
			{/if}
		</div>
        <div class="px-3 pb-20 w-full flex">
            <div class="col-led">
                <div class="led"></div>
                <div class="led {(countdown <= 4 && !isStart) ? 'on' : ''}"></div>
            </div>
            <div class="col-led">
                <div class="led"></div>
                <div class="led {(countdown <= 3 && !isStart) ? 'on' : ''}"></div>
            </div>
            <div class="col-led">
                <div class="led"></div>
                <div class="led {(countdown <= 2 && !isStart) ? 'on' : ''}"></div>
            </div>
            <div class="col-led">
                <div class="led"></div>
                <div class="led {(countdown <= 1 && !isStart) ? 'on' : ''}"></div>
            </div>
            <div class="col-led">
                <div class="led"></div>
                <div class="led {(countdown <= 0 && !isStart) ? 'on' : ''}"></div>
            </div>
        </div>
	</div>
</div>